module.exports = __webpack_public_path__ + "img/tick_red.4cac4fef.svg";